export default __webpack_public_path__ + "static/media/Zombie_Icon_SVG.8713f016.svg";